export default "__VITE_ASSET__CudPDI1Y__"